import { useQuery } from 'react-query';
import { QueryKey } from '../constants/queryKey';
import useApi from '../api';

const useHistory = (filter, cursor) => {
    const { getHistory } = useApi();

    const params = {
        ...filter,
        pageSize: 25,
        ...(cursor?.ts ? { cursor_ts: cursor.ts, cursor_id: cursor.id, direction: cursor.direction } : {}),
    };

    const query = useQuery([QueryKey.History, params], async () => {
        const response = await getHistory(params);
        return response.data;
    }, {
        enabled: !!filter?.year && !!filter?.month,
        staleTime: 0,
        keepPreviousData: true,
    });

    const { data: history, isLoading, isError, isFetched } = query;

    return {
        history,
        isLoading,
        isFetched,
        isError,
    };
};

export default useHistory;
